import { ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { APUserModeConfig } from '../../../global/components/user_mode_config/config/ap_user_mode_config';
import { APProgramSlotHelper } from '../../../global/helpers/program_slot_helper';
import { APCourseServant } from '../../../global/servants/ap_course_servant';
import { APDegreeMapQueryHelper } from '../../../plan/queries/ap_degree_map_query_helper';
import { APGenericSlot, CourseGroupSlot } from '../../builders/ap_generic_slot_builder';
import { APTerm } from '../../builders/ap_term_builder';
import { APComponentStateModel } from '../../models/ap_component_state_model';
import { MarkAsMetFacade } from '../mark_as_met/facades/mark_as_met_facade';
import { RouterHelper } from './../../helpers/router_helper';
import { CourseGroupCourseDetailOpenFacade } from './../course_detail/facades/course_group_course_detail_open_facade';

interface ITermEntry {
  id: number;
  name: string;
}

class CoursePlaceholderMenuController {
  private courseGroup: CourseGroupSlot;

  private isPlanned: boolean = false;
  private showMenu: boolean = true;
  private slotId: number;
  private showMoveToTermMenu: boolean = false;
  private removeFromTermMenu: boolean = false;
  private menuId: string;
  private isAdvisor: boolean;
  private showAdvisorMenu: boolean = false;
  private isLocked: boolean = false;

  constructor(
    private saveCourseGroupToTermCommand: ICommand,
    private removeCourseGroupFromTermCommand: ICommand,
    private removeCourseFromTermCommand: ICommand,
    private removeCourseFromTermAndAddCourseCommand: ICommand,
    private removeCourseGroupFromTermAndAddCourseGroupCommand: ICommand,
    private ngAPComponentStateModel: APComponentStateModel,
    private ngComponentCommunicatorService: CommunicatorService,
    private ngAPTermsQuery: IQuery,
    private ngAPUserModeConfig: APUserModeConfig,
    private markAsMetFacade: MarkAsMetFacade,
    private $state: ng.ui.IStateService,
    private ngAPProgramSlotHelper: APProgramSlotHelper,
    private ngAPDegreeMapQueryHelper: APDegreeMapQueryHelper,
    private ngCourseGroupCourseDetailOpenFacade: CourseGroupCourseDetailOpenFacade,
    private routerHelper: RouterHelper
  ) {}

  initialize() {
    this.showMenu = !_4.isBoolean(this.showMenu) ? true : this.showMenu;
    const isCoursePlanned = !_4.isEmpty(this.courseGroup.plannedCourse);
    this.showAdvisorMenu = isCoursePlanned && this.isAdvisor;

    this.isLocked = _4.get(this.courseGroup, 'isLockedByAdvisor', false);
    const isLockedByStatus = APCourseServant.isLockedByStatus(this.courseGroup.status);
    this.showMoveToTermMenu = !this.isLocked && !isLockedByStatus;

    const isCourseGroupPlanned = !_4.isEmpty(this.courseGroup.plannedCourseGroup);
    this.removeFromTermMenu = (isCourseGroupPlanned || isCoursePlanned) && !this.isLocked && !isLockedByStatus;

    if (this.showMoveToTermMenu && this.isMovePreventedByMarkAsMet()) {
      this.showMoveToTermMenu = false;
    }
  }

  $onInit() {
    this.isAdvisor = this.ngAPUserModeConfig.isAdvisor();
    this.menuId = _4.uniqueId();
    this.initialize();
  }

  $onChanges() {
    this.initialize();
  }

  isMovePreventedByMarkAsMet() {
    if (!this.ngAPDegreeMapQueryHelper.isMarkAsMetFeatureEnabled()) {
      return false;
    }
    return this.ngAPProgramSlotHelper.isMarkedAsMet(this.courseGroup.programSlot);
  }

  openLockUnlockDialog() {
    this.$state.go('.lock_course', {
      genericSlot: this.courseGroup,
      type: !this.isLocked ? 'lock' : 'unlock'
    });
  }

  addPlaceholder(genericSlot: CourseGroupSlot, term: ITermEntry) {
    this.saveCourseGroupToTermCommand({
      course_group: genericSlot.programSlot.course_group,
      term: term.id,
      program_slot: genericSlot.programSlot.id
    }).then((plndCourse: any) => {
      this.ngComponentCommunicatorService.publish('CLOSE_LARGE_COURSE_GROUP_PANEL');
      this.ngAPComponentStateModel.courseGroupClose(genericSlot.programSlot.id);
    });
  }

  openFlagPopup() {
    this.$state.go('.course_flag_dialog', {
      genericSlot: this.courseGroup
    });
  }

  showCourseDetails(event: any) {
    if (!this.courseGroup.plannedCourse) {
      return;
    }
    const courseNk = this.courseGroup.plannedCourse._course.nk;
    const programSlotId = this.courseGroup.programSlot.id;
    const slotType = this.courseGroup.programSlot.slot_type;
    const termId = this.courseGroup.termId;
    const title = this.courseGroup.plannedCourse._course._title;

    const courseDetails = {
      courseNk,
      programSlotId,
      slotType,
      termId,
      title
    };
    return this.routerHelper.findStateAndGo('.course_details', { courseDetails });
  }

  moveAction(genericSlot: CourseGroupSlot, term: ITermEntry) {
    if (!_4.isEmpty(genericSlot.plannedCourseGroup)) {
      this.removeCourseGroupFromTermAndAddCourseGroupCommand(
        genericSlot.plannedCourseGroup,
        genericSlot.plannedCourseGroup,
        term.id
      ).then(() => {
        this.ngComponentCommunicatorService.publish('CLOSE_LARGE_COURSE_GROUP_PANEL');
      });
    } else {
      if (!genericSlot.plannedCourse) {
        return;
      }
      this.removeCourseFromTermAndAddCourseCommand(
        {
          course: genericSlot.plannedCourse.course,
          id: genericSlot.plannedCourse.id
        },
        {
          id: genericSlot.plannedCourse.course
        },
        genericSlot.programSlot,
        genericSlot.plannedCourse.term,
        term.id
      ).then(() => {
        this.ngComponentCommunicatorService.publish('CLOSE_LARGE_COURSE_GROUP_PANEL');
      });
    }
  }

  removeAction(genericSlot: CourseGroupSlot) {
    if (!_4.isEmpty(genericSlot.plannedCourseGroup)) {
      this.removePlaceholder(genericSlot);
    } else {
      this.removeCourse(genericSlot);
    }
  }
  removeCourse(genericSlot: CourseGroupSlot) {
    this.removeCourseFromTermCommand(genericSlot.programSlot, genericSlot.plannedCourse).then(() => {
      this.ngComponentCommunicatorService.publish('CLOSE_LARGE_COURSE_GROUP_PANEL');
    });
  }
  removePlaceholder(genericSlot: CourseGroupSlot) {
    this.removeCourseGroupFromTermCommand(genericSlot.programSlot, genericSlot.plannedCourseGroup.id).then(() => {
      this.ngComponentCommunicatorService.publish('CLOSE_LARGE_COURSE_GROUP_PANEL');
    });
  }

  termItemClick(term: APTerm) {
    this.isPlanned ? this.moveAction(this.courseGroup, term) : this.addPlaceholder(this.courseGroup, term);
  }
}

class CoursePlaceholderMenu implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;

  constructor() {
    this.bindings = {
      courseGroup: '<',
      showMenu: '<',
      slotId: '<',
      isPlanned: '<'
    };
    this.controller = CoursePlaceholderMenuController;
    this.templateUrl =
      'capability-ng-academic-planner/src/global/components/course_placeholder_menu/course_placeholder_menu.html';
  }
}

angular.module('capability-ng-academic-planner').component('coursePlaceholderMenu', new CoursePlaceholderMenu());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_placeholder_menu/course_placeholder_menu.ts